const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1600,
    // lg: 1200,
    xl: 1800,
    // xl: 1536,
  },
};

export default breakpoints;
